import { PostComment } from "@/components/Customer/Ticket/MessageInputBox";
import { axios } from "@/lib/axios";

interface GetTicketsParams {
  customer_id: number;
  tab_status?: string | null;
}

export const getTickets = (params: GetTicketsParams) => {
  return axios.get("/api/v1/dataTickets/getCustomerTickets", {
    params,
  });
};

export const postComment = (postData: PostComment) => {
  return axios.post("/api/v1/dataTickets/postComment", postData);
};

export const getFormInputs = () => {
  return axios.get("/api/v1/dataTickets/getCustomerTicketFormInputs");
};

interface SubmitTicketData {
  customer_id?: string;
  files?: {
    original_filename: string;
    file_content: string;
  }[];
  [key: string]: any;
}

export const postTicket = (data: SubmitTicketData) => {
  return axios.post("/api/v1/dataTickets/postCustomerTicket", data);
};

interface SearchTicketParams {
  keyword?: string | null;
  customer_id?: number | null;
}

export const searchTicket = (params: SearchTicketParams) => {
  return axios.get("/api/v1/dataTickets/searchCustomerTickets", {
    params,
  });
};

export const getCustomerTicketTabStatus = (dataId: number) => {
  return axios.get("/api/v1/dataTickets/getCustomerTicketTabStatus", {
    params: { data_id: dataId },
  });
};

export const postCustomerTicketTabStatus = (
  dataId: number,
  tabStatusesId: number
) => {
  return axios.post("/api/v1/dataTickets/postCustomerTicketTabStatus", {
    data_id: dataId,
    tab_statuses_id: tabStatusesId,
  });
};

interface CancelScheduledMailParams {
  data_ticket_comment_id: number;
}

export const cancelScheduledMail = (params: CancelScheduledMailParams) => {
  return axios.post("/api/v1/dataTickets/cancelScheduledMail", params);
};
